module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "configure-igloohome-v2",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('account.settings.user_services_section.igloohomev2.title')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-igloohome-v2')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row-mt-15 text-center"
  }, [(_vm.user.igloohome_v2_accounts && _vm.user.igloohome_v2_accounts.length > 0) ? _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("\n              Comptes connectée :\n            ")]), _vm._v(" "), _vm._l((_vm.user.igloohome_v2_accounts), function(account) {
    return _c('div', [_c('p', {
      staticClass: "text-muted"
    }, [_vm._v("\n                " + _vm._s(account.email) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.refreshIgloohomeV2()
      }
    }
  }, [_vm._v("\n                Rafraichir les clefs\n              ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.user.igloohome_v2_accounts && _vm.user.igloohome_v2_accounts.length === 0) ? _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logIgloohomeV2()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('account.settings.user_services_section.igloohomev2.login')) + "\n            ")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-igloohome-v2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "setup-successful"
  }, [_c('div', {
    staticClass: "quick-tour"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22366ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/account/settings/ConfigureIgloohomeV2.vue
// module id = 1343
// module chunks = 0